<template>
    <modal v-bind:show.sync="show" ref="modal">
        <div slot="header">
            <h3 class="panel-title f-s-5">{{ trans('Add Upsell') }}</h3>
        </div>

        <!-- Membership picker -->
         <div v-bind:class="{'has-error': errors.has('membership_id')}" class="form-group form-group-simple">
            <label class="m-b-2">{{  trans('Membership') }}</label>
            <div v-if="selectedMembership" v-bind:key="selectedMembership.id" class="card br row m-b-6">
                <div class="column">
                    <div class="card-content row row-collapse-indent row-middle m-t-4 m-b-4">
                        <div class="slat-content column">
                            <h4 class="card-title c-primary f-s-4 m-b-0">{{ selectedMembership.name }}</h4>
                            <div class="card-type f-s-2 c-muted m-t-1">{{ membershipProducts(selectedMembership) }}</div>
                        </div>
                        <div class="slat-aside text-right m-r-4">
                            <a v-on:click.prevent="deleteMembership" class="i-container i-filled-dark btn btn-text width-auto-min p-0 m-r-0" href="#remove-membership">
                                <!-- /icons/remove.svg -->
                                <svg class="icon i-size-medium" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#FFF" cx="16" cy="16" r="16"/><path fill="#AAB2BD" fill-rule="nonzero" d="M23 10.41L21.59 9 16 14.59 10.41 9 9 10.41 14.59 16 9 21.59 10.41 23 16 17.41 21.59 23 23 21.59 17.41 16z"/></g></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if=" ! selectedMembership" class="text-center">
                <button v-on:click="addMembership" type="button" class="btn btn-text btn-text--accent btn-icon m-b-4">
                    <span class="icon i-container i-filled-accent">
                        <!-- /icons/add.svg -->
                        <svg class="icon i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M11 5v14h2V5z"/><path d="M19 11H5v2h14z"/></g></svg>
                    </span>
                    {{ trans('Add Membership') }}
                </button>
            </div>
         </div>
         <div v-if="errors.has('membership_id')" class="form-help">{{ errors.get('membership_id') }}</div>

         <!-- Pricing -->
        <div class="row row-collapse-indent">
            <div v-bind:class="{'small-4': upsell.pricing_plan.type === 'subscription', 'small-6': upsell.pricing_plan.type === 'one-time' || upsell.pricing_plan.type === 'installment-plan'}" class="column">
                <div class="form-group">
                    <label>{{ trans('Payment type') }}</label>
                    <select v-on:change="generateName" class="input__field" v-model="upsell.pricing_plan.type">
                        <option v-for="(label, key) in types" v-bind:value="key" v-bind:key="key">{{ label }}</option>
                    </select>
                </div>
            </div>
            <div v-bind:class="{'small-4': upsell.pricing_plan.type === 'subscription', 'small-6': upsell.pricing_plan.type === 'one-time' || upsell.pricing_plan.type === 'installment-plan'}" class="column">
                <div v-bind:class="{'has-error': errors.has('pricing_plan.price')}" class="form-group form-group-addon">
                    <label>
                        {{ trans('Price') }}
                        <input class="input__field" type="number" step="any" v-model="upsell.pricing_plan.price" placeholder="0">
                    </label>
                    <span class="btn form-append btn-text width-auto-min">{{ currency }}</span>
                </div>
            </div>
            <div v-if="upsell.pricing_plan.type === 'subscription' || upsell.pricing_plan.type === 'installment-plan'" v-bind:class="{'small-4': upsell.pricing_plan.type === 'subscription', 'small-6': upsell.pricing_plan.type === 'one-time' || upsell.pricing_plan.type === 'installment-plan'}" class="column">
                <div class="form-group">
                    <label>{{ trans('Every') }}</label>
                    <select v-on:change="generateName" class="input__field" v-model="upsell.pricing_plan.interval">
                        <option v-for="(label, key) in intervals" v-bind:value="key" v-bind:key="key">{{ label }}</option>
                    </select>
                </div>
            </div>
            <div v-if="upsell.pricing_plan.type === 'installment-plan'" class="column small-6">
                <div class="form-group" v-bind:class="{'has-error': errors.has('installments')}">
                    <label>
                        {{ trans('Number of payments') }}
                        <input class="input__field" type="number" v-model="upsell.pricing_plan.interval_count" placeholder="0" min="2">
                    </label>
                </div>
                <div v-if="errors.has('installments')" class="form-help">{{ errors.get('installments') }}</div>
            </div>
        </div>
        <div v-if="errors.has('pricing_plan.price')" class="form-help">{{ errors.get('pricing_plan.price') }}</div>

        <div v-if="upsell.pricing_plan.type === 'subscription' || upsell.pricing_plan.type === 'installment-plan'" class="row row-collapse-indent">
            <div class="column small-6">
                <div class="form-group">
                    <label>
                        {{ trans('Trial Period (Days)') }}
                        <input class="input__field" type="number" v-model="upsell.pricing_plan.trial_period_days" placeholder="0" step="1" max="730">
                    </label>
                </div>
                <div v-if="errors.has('trial_period_days')" class="form-help">{{ errors.get('trial_period_days') }}</div>
            </div>
            <div class="column small-6">
                <div class="form-group form-group-addon">
                    <label>
                        {{ trans('Setup fee (Charged today)') }}
                        <input class="input__field" type="number" step="any" v-model="upsell.pricing_plan.setup_price" placeholder="0">
                    </label>
                    <span class="btn form-append btn-text width-auto-min">{{ currency }}</span>
                </div>
            </div>
        </div>

        <!-- Name -->
        <div v-if="upsell.pricing_plan.type === 'subscription' || upsell.pricing_plan.type === 'installment-plan'" v-bind:class="{'has-error': errors.has('pricing_plan.name')}" class="form-group">
            <label>
                {{ trans('Upsell plan name') }}
                <input class="input__field" type="text" v-model="upsell.pricing_plan.name" v-on:keyup="manuallyChangedName = true">
            </label>
        </div>
        <div v-if="errors.has('pricing_plan.name')" class="form-help">{{ errors.get('pricing_plan.name') }}</div>

        <!-- Original Price -->
        <div class="form-group form-group-addon">
            <label>
                {{ trans('Original Price') }}
                <input class="input__field" type="number" step="any" v-model="upsell.original_price" placeholder="0">
            </label>
            <span class="btn form-append btn-text width-auto-min">{{ currency }}</span>
        </div>

        <div slot="footer" class="p-b-6">
            <div class="row row-collapse">
                <div class="column">
                    <button type="button" class="btn btn-primary m-r-3" v-on:click="saveUpsell">{{ trans('Save') }}</button>
                </div>
                <div class="text-right">
                    <button type="button" class="btn btn-outline btn-outline--alert" v-on:click="deleteUpsell">{{ trans('Delete') }}</button>
                </div>
            </div>
        </div>

        <membership-picker-modal
            v-bind:memberships="memberships"
            v-on:select-membership="selectMembership"
            ref="membership-picker-modal"
        ></membership-picker-modal>
    </modal>
</template>
<script>
import Modal from '../modals/Modal.vue';
import MembershipPickerModal from '../memberships/MembershipPickerModal.vue';
import HasMembershipProducts from '../../mixins/HasMembershipProducts.js';
import Errors from '../../errors.js';
import {
    PLAN_TYPE_ONE_TIME, PLAN_TYPE_SUBSCRIPTION,
    PLAN_INTERVAL_DAY, PLAN_INTERVAL_WEEK, PLAN_INTERVAL_YEAR, PLAN_INTERVAL_MONTH, PLAN_INTERVAL_QUARTER, PLAN_INTERVAL_2_WEEKS, PLAN_INTERVAL_6_MONTHS,
    PLAN_TYPE_INSTALLMENT_PLAN
} from '../../constants.js';
import { upsellValidationUrl } from '../../routes.js';

export default {
    mixins: [
        HasMembershipProducts,
    ],
    components: {
        Modal,
        MembershipPickerModal
    },
    props: {
        memberships: {
            type: Array,
            required: true,
        },
        parent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            modal: null,
            upsell: this.getEmptyUpsell(),
            selectedMembership: null,
            errors: new Errors(),
            currency: window.Kourses.currency,
            types: {
                [PLAN_TYPE_ONE_TIME]: this.trans('One-time Payment'),
                [PLAN_TYPE_SUBSCRIPTION]: this.trans('Subscription'),
                [PLAN_TYPE_INSTALLMENT_PLAN]: this.trans('Installment Plan'),
            },
            intervals: {
                [PLAN_INTERVAL_DAY]: this.trans('day'),
                [PLAN_INTERVAL_WEEK]: this.trans('week'),
                [PLAN_INTERVAL_2_WEEKS]: this.trans('2 weeks'),
                [PLAN_INTERVAL_MONTH]: this.trans('month'),
                [PLAN_INTERVAL_QUARTER]: this.trans('quarter'),
                [PLAN_INTERVAL_6_MONTHS]: this.trans('6 months'),
                [PLAN_INTERVAL_YEAR]: this.trans('year'),
            },
            index: null,
            processing: false,
            manuallyChangedName: false,
        }
    },
    watch: {
        show(newValue) {
            if (newValue === false) {
                this.upsell = this.getEmptyUpsell();
                this.selectedMembership = null;
                this.index = null;
                this.errors.clear();
            }
        },
    },
    methods: {
        addMembership() {
            this.modal.show = true;
        },
        /**
         * Selects a membership from the membership picker modal.
         * @param {Object} membership - The selected membership.
         */
        selectMembership(membership) {
            this.selectedMembership = membership;
            this.upsell.membership_id = membership.id;
        },
        /**
         * Trigger delete event and hides the modal.
         */
        deleteUpsell() {
            this.$emit('delete');
            this.show = false;
        },
        /**
         * It validates the upsell data and emits a save event with the upsell data.
         * If there are validation errors, it records them in the errors object.
         */
        saveUpsell() {
            this.errors.clear();
            this.processing = true;

            // We need to reset unused plan fields (for example, one-time upsell does not have interval or trial or setup price)
            if (this.upsell.pricing_plan.type === PLAN_TYPE_ONE_TIME) {
                this.upsell.pricing_plan.interval = PLAN_INTERVAL_MONTH;
                this.upsell.pricing_plan.interval_count = 1;
                this.upsell.pricing_plan.trial_period_days = null;
                this.upsell.pricing_plan.setup_price = null;
            } else if (this.upsell.pricing_plan.type === PLAN_TYPE_SUBSCRIPTION) {
                this.upsell.pricing_plan.interval_count = 1;
            }

            return window.axios.post(upsellValidationUrl(this.parent.encoded_id), this.upsell)
                .then(() => {
                    this.processing = false;
                    this.$emit('save', this.upsell);
                    this.show = false;
                })
                .catch((error) => {
                    this.processing = false;
                    this.errors.record(error.response.data);
                });
        },
        /**
         * It sets the selectedMembership to null and hides the modal.
         */
        deleteMembership() {
            this.selectedMembership = null;
            this.modal.show = false;
        },
        /**
         * Loads the upsell data into the component.
         * It loads the selected membership if it exists.
         * @param {Object} data - The upsell data to load.
         */
        loadUpsell(data) {
            this.upsell = data;

            if (data.membership_id) {
                this.selectedMembership = this.memberships.find((membership) => membership.id === data.membership_id);
            }
        },
        /**
         * Returns an empty upsell object with default values.
         * @return {Object} The empty upsell object.
         */
        getEmptyUpsell() {
            return {
                encoded_id: null,
                membership_id: null,
                original_price: null,
                pricing_plan: {
                    name: this.trans('One-Time'),
                    type: PLAN_TYPE_ONE_TIME,
                    interval: PLAN_INTERVAL_MONTH,
                    interval_count: 1,
                    price: null,
                    trial_period_days: null,
                    setup_price: null,
                    currency: window.Kourses.currency,
                },
            };
        },
        /**
         * Generate plan name based on type and interval.
         *
         * @return  {String}
         */
         generateName() {
            if (this.manuallyChangedName) {
                return;
            }

            let newName = this.trans('Free');

            if (this.upsell.pricing_plan.type === PLAN_TYPE_ONE_TIME) {
                newName = this.trans('One-Time');
            } else if (this.upsell.pricing_plan.type === PLAN_TYPE_INSTALLMENT_PLAN) {
                newName = this.trans('Installments');
            } else if (this.upsell.pricing_plan.type === PLAN_TYPE_SUBSCRIPTION) {
                if (this.upsell.pricing_plan.interval === 'day') {
                    newName = this.trans('Daily Subscription');
                } else if (this.upsell.pricing_plan.interval === 'week') {
                    newName = this.trans('Weekly Subscription');
                } else if (this.upsell.pricing_plan.interval === '2-weeks') {
                    newName = this.trans('Bi-weekly Subscription');
                } else if (this.upsell.pricing_plan.interval === 'month') {
                    newName = this.trans('Monthly Subscription');
                } else if (this.upsell.pricing_plan.interval === 'quarter') {
                    newName = this.trans('Quarterly Subscription');
                } else if (this.upsell.pricing_plan.interval === '6-months') {
                    newName = this.trans('Bi-annual Subscription');
                } else if (this.upsell.pricing_plan.interval === 'year') {
                    newName = this.trans('Yearly Subscription');
                }
            }

            this.upsell.pricing_plan.name = newName;
        },
    },
    mounted() {
        this.modal = this.$refs['membership-picker-modal'];
    }
}
</script>